import React, { Fragment, useState, useEffect } from 'react';
import {
  User, Mail, Lock, Settings, LogOut, Link as LinkIcon,
} from 'react-feather';
import { withRouter } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import { Link } from 'react-router-dom';
import {
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { firebaseApp } from '../../../data/config';
import man from '../../../../images/dashboard/user.png';
import {
  EditProfile, English, Inbox, LockScreen, Russian, Ukrainian,
} from '../../../constant';
import authStorage from '../../../storages/mobx/authStorage';
import ModalGetManagerLink from './ModalGetManagerLink';
import chatStorage from '../../../pages/Chat/chatStorage';
import appState from '../../../storages/mobx/appState';
import ModalManagerInviteUser from './ModalManagerInviteUser';

const UserMenu = ({ history, t }) => {
  const [profile, setProfile] = useState('');

  const Logout_From_Firebase = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.removeItem('profileURL');
    localStorage.removeItem('token');
    firebaseApp.auth().signOut();
    authStorage.clearCredientals();
    // history.push('/app');
    return false;
  };

  const [dropdownOpen, setOpen] = useState(false);

  return (
    <>
      {/* <Dropdown isOpen={dropdownOpen} toggle={() => setOpen(!dropdownOpen)} className="personal-dropdownContainer"> */}
      {/*  <DropdownToggle className="" outline color="transparent"> */}
      {/*    <img */}
      {/*      className="align-self-center pull-right img-50 rounded-circle lazyloaded" */}
      {/*      src={authStorage.isLogged ? (authStorage.avatar ? authStorage.avatar : man) : man} */}
      {/*      alt="header-user" */}
      {/*    /> */}
      {/*    /!* <div className="dotted-animation"> *!/ */}
      {/*    /!*  <span className="animate-circle" /> *!/ */}
      {/*    /!*  <span className="main-circle" /> *!/ */}
      {/*    /!* </div> *!/ */}
      {/*  </DropdownToggle> */}
      {/*  <DropdownMenu className="personal-dropdownMenu"> */}
      {/*    <DropdownItem */}
      {/*      className="personal-dropdownItem" */}
      {/*      onClick={(e) => { */}
      {/*        e.stopPropagation(); */}
      {/*        e.preventDefault(); */}
      {/*        chatStorage.getManagerLink(authStorage.id); */}
      {/*      }} */}
      {/*    > */}
      {/*      <Link to="/app/users/editProfile"> */}
      {/*        <LinkIcon /> */}
      {/*        Personal link */}
      {/*      </Link> */}
      {/*    </DropdownItem> */}
      {/*    <DropdownItem onClick={() => handleSetLanguage('ru')}> */}
      {/*      <a href="#javascript" data-lng="ru"> */}
      {/*        <i className="flag-icon flag-icon-ru" /> */}
      {/*        {' '} */}
      {/*        {Russian} */}
      {/*      </a> */}
      {/*    </DropdownItem> */}
      {/*    <DropdownItem onClick={() => handleSetLanguage('ua')}> */}
      {/*      <a href="#javascript" data-lng="ua"> */}
      {/*        <i className="flag-icon flag-icon-ua" /> */}
      {/*        {' '} */}
      {/*        {Ukrainian} */}
      {/*      </a> */}
      {/*    </DropdownItem> */}
      {/*    <DropdownItem divider /> */}
      {/*  </DropdownMenu> */}
      {/* </Dropdown> */}
      <li className="onhover-dropdown">
        <div className="media align-items-center">
          <img
            className="align-self-center pull-right img-50 rounded-circle lazyloaded"
            src={authStorage.isLogged ? (authStorage.avatar ? authStorage.avatar : man) : man}
            alt="header-user"
          />
        </div>
        <ul className="profile-dropdown onhover-show-div p-20 profile-dropdown-hover">
          <li>
            {/* <a href="/app/users/editProfile"> */}
            <Link to="/app/users/editProfile">
              <User />
              {t('users.Edit profile')}
            </Link>
            {/* </a> */}
          </li>
          {/* <li> */}
          {/*  <Link to={`${process.env.PUBLIC_URL}/email-app/emailDefault`}> */}
          {/*    <Mail /> */}
          {/*    {Inbox} */}
          {/*  </Link> */}
          {/* </li> */}
          {/* <li> */}
          {/*  <a href="#javascript"> */}
          {/*    <Lock /> */}
          {/*    {LockScreen} */}
          {/*  </a> */}
          {/* </li> */}
          <li>
            <a
              href=""
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                chatStorage.getManagerLink(authStorage.id);
              }}
            >
              <LinkIcon />
              {t('Personal link')}
            </a>
          </li>
          <li>
            <a onClick={Logout_From_Firebase} href="#">
              <LogOut />
              {' '}
              {t('Log out')}
            </a>
          </li>
        </ul>
      </li>
      <ModalGetManagerLink />
      {chatStorage.managerInviteLinkDialogOpened && <ModalManagerInviteUser />}
    </>
  );
};

export default translate(withRouter(observer(UserMenu)));
